<!--
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-01 16:29:21
 * @LastEditors: cooky
 * @LastEditTime: 2021-05-11 14:57:39
-->
<template>
  <SModal :visible="visible" :allowClose="true" class="s-modal s-confirm s-confirm--l">
    <div class="modal-tip">
      <i class="icon icon-close" @click="handleClose"/>
      <div class="title">{{ $t('order_confirm') }}</div>
      <div class="title-tip">{{ $t('order_confirm_gok') }}</div>
      <div class="content">
        <div>
          <div class="goods-item order-goods">
            <div class="goods-item-img">
              <img :src="require(`@/static/assets/ui/pc/props-img${goods.tag || ''}.png`)"/>
            </div>
            <div class="goods-item-info">
              <div class="goods-item-name" v-html="goods.product_name"></div>
              <!-- <div class="goods-item-desc" v-if="goods.info">{{ $t("remark") }}：{{ goods.info }}</div> -->
              <div class="goods-item-desc" v-if="goods.info">{{ $t("remark") }}{{ goods.info }}</div>
              <!-- 钻石和特权卡都是根据名字显示备注 -->
              <div class="goods-item-desc" v-else>{{ $t(`tab${ goods.tag }_remark`) }}{{ goods.tag !== 2 ? goods.product_name : '' }}{{ lang === 'en_us' ? ' Now':'' }}</div>
            </div>
            <div class="goods-item-buy">
              <div class="goods-item-price">{{ $t('money_symbol') }}{{ goods.price }}</div>
              <div class="goods-item-num">x1</div>
            </div>
          </div>
          <div class="order-info">
            <div class="order-info-item">{{ $t("server") }}<span>{{ serverName }}</span></div>
            <div class="order-info-item">{{ $t("role_nickname") }}<span>{{ roleName }}</span></div>
            <div class="order-info-item">{{ $t("role_id") }}<span>{{ roleId }}</span></div>
            <div class="order-info-item">{{ $t("payway") }}<img src="@/static/assets/ui/pc/logo-mycard.png"/></div>
          </div>
          <s-button class="large" @click="handleBuy" :loading="buyingLoading">{{ $t('confirm_order') }}</s-button>
          <div class="user-protocol">
            <span :class="['custom-radio', {activated: isProtocolSelected}]" @click="agreeProtocol"></span>
            <div class="protocol-detail">
              {{ $t("protocal_text") }}
              <a href="https://www.ariel.com.tw/%E7%94%A8%E6%88%B6%E5%8D%94%E8%AD%B0/" target="__blank" class="link">{{ $t('text_protocal') }}</a>
              {{ $t("and") }}
              <a href="https://www.ariel.com.tw/ariel-privacy-policy/" target="__blank" class="link">{{ $t('privacy_policy') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SModal>
</template>
<script>
import ServerRole from '../infoBinding/ServerRoleForm'
import { mapGetters } from 'vuex'
import { pay } from '@/api'
import { v4 as uuidv4 } from 'uuid'
import { setUid } from '@/util/wrapperUtil'
import { ERROR_CONFIG_MAP } from '@/config/error'

export default {
  name: 'ComfirmOrder',
  components: { ServerRole },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    goods: {
      type: Object,
      require: true,
      default: () => {}
    },
    payload: {
      type: String,
      default: '2' // 1搜索购买、2主页（快速）购买、3推荐栏购买
    }
  },
  data () {
    return {
      isProtocolSelected: false,
      buyingLoading: false
    }
  },
  computed: {
    ...mapGetters(['serverName', 'roleName', 'roleId', 'lang'])
  },
  methods: {
    handleClose () {
      this.$emit('update:visible', false)
    },
    agreeProtocol () {
      this.isProtocolSelected = !this.isProtocolSelected
    },
    handleBuy () {
      if (!this.isProtocolSelected) {
        this.$tip({
          content: this.$t('check_user_agreement')
        })
        return
      }
      this.buying()

      // 创建订单失败，要关闭弹窗
    },
    async buying () {
      this.buyingLoading = true
      const uid = uuidv4()
      setUid(uid)
      const { code, data } = await pay({
        logical_region_id: +process.env.VUE_APP_LOGICAL_REGION_ID,
        id: +this.goods.id,
        return_url: location.origin + '/v1/callback/MycardCallback?uid=' + uid,
        pay_method: '1',
        payload: this.payload// find_way: 1搜索购买、2主页（快速）购买、3推荐栏购买
      })
      this.buyingLoading = false
      if (code === 0) {
        location.href = data.pay_url
        return
      } else if (code !== 1012) { // 1012登陆过期，在request拦截
        this.$info({
          content: () => {
            return (
              <div class="error">
                <div class="desc">{ERROR_CONFIG_MAP[code] ? this.$t(ERROR_CONFIG_MAP[code]) : this.$t('create_order_fail_tip')}</div>
                <div class="code">{'code:' + code}</div>
              </div>
            )
          },
          okText: this.$t('knowed')
        })
        this.$parent.$parent.getCommodity()
      }
      this.handleClose()
    }
  }
}
</script>
<style lang="less" scoped>
.order-goods {
    margin-top: 24px;
}
.order-info {
    font-size: 16px;
    color: #333333;
    padding: 0 5px;
    text-align: left;
    &-item {
        padding: 20px 10px;
        &:not(:last-child) {
            border-bottom: 1px dashed #dbdbdd;
        }
        span {
            float: right;
        }
        img {
            float: right;
        }
    }
}
 .content /deep/ .s-button {
    position: inherit;
    margin: 30px 0;
}
.user-protocol {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #707070;
    text-align: center;
    >.custom-radio {
      position: relative;
      display: inline-block;
      width: 12px;
      height: 12px;
      border: 1px solid #777778;
      cursor: pointer;
      margin-right: 6px;
      background: url('../../static/assets/ui/mobile/checkbox.png') no-repeat;
      background-size: 100% 100%;
      border: 0;
      &.activated {
        background-image: url('../../static/assets/ui/mobile/checkbox-checked.png');
        background-color: transparent;
        &::after {
          display:none;
        }
      }
      // &.activated {
      //   background-color: #912a22;
      //   &::after {
      //       width: 3px;
      //       height: 6px;
      //       position: absolute;
      //       top: 4px;
      //       left: 2px;
      //       position: absolute;
      //       display: table;
      //       border: 2px solid #fff;
      //       border-top: 0;
      //       border-left: 0;
      //       transform: rotate(45deg) scale(1) translate(-50%,-50%);
      //       opacity: 1;
      //       transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s;
      //       content: " ";
      //   }
      // }
    }
    .link {
      color: #707070;
    }
  }
  @media screen and (max-width: 750px) {
    .order-goods {
        margin: 3.4667rem /* 26/7.5 */ auto 0;
    }
    .order-info {
        font-size: 2.6667rem /* 20/7.5 */;
        &-item {
            padding: 3.4667rem /* 26/7.5 */ 1.3333rem /* 10/7.5 */;
            img {
                width: 18.4rem /* 138/7.5 */;
                margin-top: -2.6667rem;
            }
        }
    }
     .content /deep/ .s-button {
        position: inherit;
        margin: 3.7333rem /* 28/7.5 */ 0;
    }
    .user-protocol {
        font-size: 2.4rem /* 18/7.5 */;
        padding: 0 2.2667rem;
        // align-items: unset;
        text-align: left;
        .custom-radio {
          margin-top: 2px;
          width: 2.4rem /* 18/7.5 */;
          height: 2.4rem /* 18/7.5 */;
        }
        a.link {
            color: #e8691c;
        }
    }
  }
</style>
